import React from 'react';
import styled from 'styled-components';

const StyledTitle = styled.h1`
  color: var(--primary);
  margin: 0.5em 0;
  text-align: center;
  font-size: 1.9rem;
  @media (max-width: 576px) {
    font-size: 1.4rem;
    text-align: center;
  }
`;

function Title({ children }) {
  return <StyledTitle>{children}</StyledTitle>;
}

export default Title;
